import { Deck } from "./deck";
import { DeliveryDining } from "./delivery_dining";
import { DirectionsBike } from "./directions_bike";
import { DirectionsBoat } from "./directions_boat";
import { DirectionsBus } from "./directions_bus";
import { DirectionsCar } from "./directions_car";
import { DirectionsRailway } from "./directions_railway";
import { DirectionsRun } from "./directions_run";
import { DirectionsSubway } from "./directions_subway";
import { DirectionsWalk } from "./directions_walk";
import { Domain } from "./domain";

const iconsList = [
  { label: "Deck", code: <Deck /> },
  { label: "DeliveryDining", code: <DeliveryDining /> },
  { label: "DirectionsBike", code: <DirectionsBike /> },
  { label: "DirectionsBoat", code: <DirectionsBoat /> },
  { label: "DirectionsBus", code: <DirectionsBus /> },
  { label: "DirectionsCar", code: <DirectionsCar /> },
  { label: "DirectionsRailway", code: <DirectionsRailway /> },
  { label: "DirectionsRun", code: <DirectionsRun /> },
  { label: "DirectionsSubway", code: <DirectionsSubway /> },
  { label: "DirectionsWalk", code: <DirectionsWalk /> },
  { label: "Domain", code: <Domain /> },
];

export {
  iconsList,
  Deck,
  DeliveryDining,
  DirectionsBike,
  DirectionsBoat,
  DirectionsBus,
  DirectionsCar,
  DirectionsRailway,
  DirectionsRun,
  DirectionsSubway,
  DirectionsWalk,
  Domain,
};
